function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Logger from "./Logger.js";
import { INFO } from "./LoggerLevel.js";
class DefaultLogger extends Logger {
  constructor() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INFO;
    super(null, level);
    _defineProperty(this, "modules", void 0);
    this.modules = {};
  }
  module(name) {
    if (this.modules[name] == null) {
      this.modules[name] = new Logger(name, this.level);
    }
    return this.modules[name];
  }
  setLogLevel(level) {
    super.setLogLevel(level);
    if (this.modules == null) {
      return;
    }
    var keys = Object.keys(this.modules);
    for (var i = 0; i < keys.length; i += 1) {
      this.modules[keys[i]].setLogLevel(level);
    }
  }
}
export default DefaultLogger;
//# sourceMappingURL=DefaultLogger.js.map